export default __webpack_public_path__ + "static/media/1.f49b7014.png";